module.exports = __webpack_public_path__ + "media/img/avatars/profiles/avatar-1-b42f730bc711cff2f549ff3a1e515408.jpg";